<template>
    <div
        class="modal"
    >
        <div class="modal-content">
            <base-modal-close
                @close-modal="$emit('close')"
            />
            <integration-info
                :integration-name="integration.name"
                :integration-title="integration.title"
                :integration-text="integration.text"
                :integration-link="integration.link"
                :help-scout-id="integration.helpScoutId"
            />
            <integration-tools
                :integration-plugins="integrationsTools"
            />
        </div>
    </div>
</template>

<script>
import IntegrationInfo from './IntegrationInfo';
import IntegrationTools from './IntegrationTools';
import modal from '@/mixins/modal';
import { mapState } from 'vuex';

export default {
    components: {
        IntegrationInfo,
        IntegrationTools,
    },

    mixins: [modal],

    props: {
        integration: {
            type: Object,
            default: () => ({}),
        },
    },

    computed: {
        ...mapState(['integrations']),

        /**
         * Returns integration tools
         *
         * @returns  {object}  Integration type tools
         */
        integrationsTools() {
            return this.integrations?.[this.integration.type];
        },
    },
};
</script>
